import mixpanel from 'mixpanel-browser';
import * as Sentry from "@sentry/react";

export function doLogout(callback) {
  {
    const scope = Sentry.getCurrentScope();
    scope.setUser(null);
    scope.setTag('user_email', undefined);
  };

  mixpanel.track('Logout');
  mixpanel.reset();

  // Log out using Auth0 callback
  callback({ logoutParams: { returnTo: process.env.NEXT_PUBLIC_AUTH0_LOGOUT_URI } });
}

export function logAuthenticationRequired(name) {
  console.debug(`loginWithRedirect() from ${name}`);
  Sentry.addBreadcrumb({
    category: 'auth',
    message: `loginWithRedirect() from ${name}`,
    level: 'info',
  });
  Sentry.captureMessage(`loginWithRedirect() via withAuthenticationRequired()`, 'debug');
}
